import React, { useState } from 'react'
import ModalComponent from '../../views/ModalComponent'
import Input from './views/Input'
import httpInstance from '../../services/Http'
import { notificationsEntity } from '../../entities/NotificationsEntity'
import NotificationDTO from '../../DTO/NotificationDTO'
import messages, { notifications } from '../../constants/messages'

const EditionCreate = () => {
  const [open, setOpen] = useState(false)

  const [form, setForm] = useState({
    edition: '',
    description: '',
  })

  const toggleModal = () => {
    setOpen(!open)
  }

  const handleInputChange = (value, name) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }))
  }

  const handleSave = async () => {
    try {
      await httpInstance.endpoints.editionTexts.create({
        ...form,
        description: `Velkommen til Landsskytterstevnet ${form.edition} Steinkjer. Dette er den offisielle resultatwebben for LS${form.edition}.`,
      })
      notificationsEntity.addNotification(
        new NotificationDTO(
          null,
          messages.success,
          form.edition,
          NotificationDTO.types.success,
          NotificationDTO.defaultDelay
        )
      )
      toggleModal()
    } catch (e) {
      notificationsEntity.addNotification(
        new NotificationDTO(
          null,
          messages.error,
          notifications.somethingWentWrong,
          NotificationDTO.types.error,
          NotificationDTO.defaultDelay
        )
      )

      toggleModal()
    }
  }

  const createLabel = 'Opprett utgave'

  return (
    <>
      <button onClick={toggleModal} className="btn btn--default">
        {createLabel}
      </button>
      <ModalComponent
        handleClose={toggleModal}
        isOpened={open}
        className="modal-component--is-menu-edit"
        title={createLabel}
      >
        <>
          <Input
            heading="Utgave"
            placeholder="Skriv inn utgave"
            handleChange={(value) => handleInputChange(value, 'edition')}
            value={form.edition}
          />

          <div className="admin-modal__row">
            <button className="btn" onClick={handleSave}>
              {createLabel}
            </button>
          </div>
        </>
      </ModalComponent>
    </>
  )
}

export default EditionCreate
